module.exports = __webpack_public_path__ + "statics/img/step-zh.87a46996.gif";